/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import moment from 'moment';
import classNames from 'classnames';
import Calendar from 'icons/calendar';
import {
  CampaignsFilter,
  DynamicFilter,
  AccountsFilter,
  SequencesFilter,
  CampaignStatusFilter,
} from 'components/filters';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';
import DateRangePicker, { ANCHOR_RIGHT } from 'components/forms/DateRangePicker';
import { DATE_FORMAT_SLASHES } from 'constants/config';
import {
  resetDashboard,
  loadDashboardStats,
  updateDashboardParams,
} from 'redux/actions/dashboardActions';
import { getTimezoneAndUTCOffset, prepareFilterParams } from 'utils/report';
import { getFilterStyle } from 'styles/const';
import { AbilityContext } from 'utils/permissions';

const styles = (theme) => ({
  filtersWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  ...getFilterStyle(theme),
});

const LAST_WEEK_DATE_OPTION = { label: 'Last 7 days', value: 'weeks' };
const LAST_MONTH_DATE_OPTION = { label: 'Last 30 days', value: 'months' };
const LAST_YEAR_DATE_OPTION = { label: 'Last 365 days', value: 'years' };
const CUSTOM_DATE_OPTION = { label: 'Custom', value: 'custom_date_range' };

const DATE_OPTIONS = [
  LAST_WEEK_DATE_OPTION,
  LAST_MONTH_DATE_OPTION,
  LAST_YEAR_DATE_OPTION,
  CUSTOM_DATE_OPTION,
];

const FILTER_ACCOUNT = 'account';
const FILTER_CAMPAIGN_NAME = 'campaign_name';
const FILTER_CAMPAIGN_STATUS = 'campaign_status';
const FILTER_SEQUENCE = 'suquence';


const DashboardFilters = (props) => {
  const { classes } = props;

  const defaultFilters = {
    account__id: [],
    campaign__id: [],
    campaign_status: [],
    sequences__id: [],
  };

  const [filterParams, setFilterParams] = useState({
    dateSelector: LAST_MONTH_DATE_OPTION,
    ...defaultFilters,
    startDate: moment().subtract(30, 'd').local(),
    endDate: moment().local(),
  });

  const [showDatepicker, setShowDatePicker] = useState(false);
  const [anchorDateMenu, setAnchorDateMenu] = useState(null);

  const [haveInitialDashboardParams, setHaveInitialDashboardParams] = useState(true);

  useEffect(() => {
    props.resetDashboard();
    // eslint-disable-next-line no-use-before-define
    fetchDashboardGraphData();
  }, []);

  const fetchDashboardGraphData = async (params=filterParams) => {
    const lastPeriodParams = {...filterParams, ...params};

    lastPeriodParams.startDate = lastPeriodParams.startDate.clone();
    lastPeriodParams.endDate = lastPeriodParams.endDate.clone();

    if (lastPeriodParams.dateSelector === LAST_WEEK_DATE_OPTION) {
      lastPeriodParams.startDate = lastPeriodParams.startDate.subtract(1, 'weeks');
      lastPeriodParams.endDate = lastPeriodParams.endDate.subtract(1, 'weeks');
    } else if (lastPeriodParams.dateSelector === LAST_MONTH_DATE_OPTION) {
      lastPeriodParams.startDate = lastPeriodParams.startDate.subtract(1, 'months');
      lastPeriodParams.endDate = lastPeriodParams.endDate.subtract(1, 'months');
    } else if (lastPeriodParams.dateSelector === LAST_YEAR_DATE_OPTION) {
      lastPeriodParams.startDate = lastPeriodParams.startDate.subtract(1, 'years');
      lastPeriodParams.endDate = lastPeriodParams.endDate.subtract(1, 'years');
    } else {
      const daysDiff = lastPeriodParams.endDate.diff(lastPeriodParams.startDate, 'days');
      lastPeriodParams.startDate = lastPeriodParams.startDate.subtract(daysDiff, 'days');
      lastPeriodParams.endDate = lastPeriodParams.endDate.subtract(daysDiff, 'days');
    }

    props.loadDashboardStats({
      ...prepareFilterParams({
        ...filterParams,
        ...params,
        lastPeriodStartDate: lastPeriodParams.startDate,
        lastPeriodEndDate: lastPeriodParams.endDate,
      }),
      ...getTimezoneAndUTCOffset(),
    });
    
    if (!haveInitialDashboardParams) {
      props.updateDashboardParams(params);
    } else {
      setHaveInitialDashboardParams(false);
    }
  };

  const onResetSelectedFilter = (filter) => {
    const newParams = {};
    switch (filter) {
      case FILTER_ACCOUNT:
        newParams.account__id = [];
        break;
      case FILTER_CAMPAIGN_NAME:
        newParams.campaign__id = [];
        break;
      case FILTER_CAMPAIGN_STATUS:
        newParams.campaign_status = [];
        break;
      case FILTER_SEQUENCE:
        newParams.sequences__id = [];
        break;
      default:
        break;
    }
    setFilterParams({ ...filterParams, ...newParams });
  };

  const onDeleteFilter = (selectedFilter) => {
    const newState = {};

    switch (selectedFilter) {
      case FILTER_CAMPAIGN_NAME:
        newState.campaign__id = [];
        break;
      case FILTER_CAMPAIGN_STATUS:
        newState.campaign_status = [];
        break;
      case FILTER_ACCOUNT:
        newState.account__id = [];
        break;
      case FILTER_SEQUENCE:
        newState.sequences__id = [];
        break;
      default:
        break;
    }
    setFilterParams({
      ...filterParams,
      ...newState,
    });
    setFilterParams(params => {
      fetchDashboardGraphData(params);
      return params;
    });
  };

  const onResetFilters = () => {
    const newState = {
      ...filterParams,
      ...defaultFilters,
    };
    setFilterParams(newState);
    setFilterParams(params => {
      fetchDashboardGraphData(params);
      return params;
    });
  };

  const handleChangeAccounts = (accounts) => {
    setFilterParams({
      ...filterParams,
      account__id: accounts
    });
    setFilterParams(prevState => {
      fetchDashboardGraphData(prevState);
      return prevState;
    });
  }

  const handleChangeCampaigns = (campaigns) => {
    setFilterParams({
      ...filterParams,
      campaign__id: campaigns,
    });
    setFilterParams(prevState => {
      fetchDashboardGraphData(prevState);
      return prevState;
    });
  };

  const handleChangeStatus = (status) => {
    setFilterParams({
      ...filterParams,
      campaign_status: status,
    });
    setFilterParams(prevState => {
      fetchDashboardGraphData(prevState);
      return prevState;
    });
  }

  const handleChangeSequences = (sequences) => {
    setFilterParams({
      ...filterParams,
      sequences__id: sequences,
    });
    setFilterParams(prevState => {
      fetchDashboardGraphData(prevState);
      return prevState;
    });
  };

  const handleDateChange = (startDate, endDate) => {
    if (startDate && endDate) {
      setFilterParams({
        ...filterParams,
        startDate,
        endDate,
      });
      setFilterParams(prevState => {
        setShowDatePicker(!showDatepicker);
        fetchDashboardGraphData(prevState);
        return prevState;
      });
    }
  };

  const handleOnCloseDateRange = ({startDate, endDate}) => {
    if (!startDate || !endDate) {
      setShowDatePicker(false);
    }
  };

  const handleDateMenuClick = (event) => {
    setAnchorDateMenu(event.currentTarget);
  };

  const handleDateMenuClose = () => {
    setAnchorDateMenu(null);
  };

  const handleDateChangeFilter = (dateSelector) => {
    handleDateMenuClose();

    let { startDate, endDate } = filterParams;
    switch (dateSelector) {
      case LAST_WEEK_DATE_OPTION:
        startDate = moment().subtract(7, 'd').local();
        endDate = moment().local();
        break;
      case LAST_MONTH_DATE_OPTION:
        startDate = moment().subtract(1, 'months').local();
        endDate = moment().local();
        break;
      case LAST_YEAR_DATE_OPTION:
        startDate = moment().subtract(1, 'y').local();
        endDate = moment().local();
        break;
      case CUSTOM_DATE_OPTION:
        setShowDatePicker(!showDatepicker);
        setFilterParams({
          ...filterParams,
          dateSelector
        });
        return;
      default:
        break;
    }

    if (dateSelector === filterParams.dateSelector) {
      return;
    }

    setFilterParams({
      ...filterParams,
      dateSelector,
      startDate,
      endDate,
    });

    setFilterParams(prevState => {
      if (startDate && endDate) {
        // fetchDashboardGraphData only if both startDate and endDate are present
        fetchDashboardGraphData(prevState);
      }
      return prevState
    })
  };

  const dateMenuLabel = filterParams.dateSelector !== CUSTOM_DATE_OPTION
      ? filterParams.dateSelector.label
      : `${filterParams.startDate.format(DATE_FORMAT_SLASHES)} - ${filterParams.endDate.format(DATE_FORMAT_SLASHES)}`;

  const ability = useContext(AbilityContext);

  return (
    <div className={classes.filtersWrapper}>
      <DynamicFilter
        onResetSelectedFilter={onResetSelectedFilter}
        onResetFilters={onResetFilters}
        options={[
          ...(
            ability.can('see', 'Account') ? [
              {
                key: FILTER_ACCOUNT,
                menuLabel: 'Accounts',
                onDeleteFilter,
                component: <AccountsFilter
                  value={filterParams.account__id}
                  onChange={handleChangeAccounts}
                />,
              },          
            ] : []),
          {
            key: FILTER_CAMPAIGN_NAME,
            menuLabel: 'Campaign Name',
            onDeleteFilter,
            component: <CampaignsFilter
              value={filterParams.campaign__id}
              onChange={handleChangeCampaigns}
              accountIds={filterParams.account__id}
              includeAllOption={false}
            />,
          },
          {
            key: FILTER_CAMPAIGN_STATUS,
            menuLabel: 'Campaign Status',
            onDeleteFilter,
            component: <CampaignStatusFilter
              value={filterParams.campaign_status}
              onChange={handleChangeStatus}
            />,
          },
          {
            key: FILTER_SEQUENCE,
            menuLabel: 'Sequences',
            onDeleteFilter,
            component: <SequencesFilter
              value={filterParams.sequences__id}
              onChange={handleChangeSequences}
              accountIds={filterParams.account__id}
              campaignIds={filterParams.campaign__id}
            />,
          },
        ]}
      />
      {!showDatepicker ?
        <React.Fragment>
          <button
            className = { classNames(classes.dateSelectorBtn,  {open: anchorDateMenu}) }
            
            onClick={handleDateMenuClick}
          >
            <Calendar className={classes.filterIcon} viewBox="0 0 17 17" />
            {dateMenuLabel}
          </button>
          <Menu
            id="ds-date-menu"
            anchorEl={anchorDateMenu}
            keepMounted
            open={Boolean(anchorDateMenu)}
            onClose={handleDateMenuClose}
          >
            {DATE_OPTIONS.map(option => (
              <MenuItem onClick={() => handleDateChangeFilter(option)}>
                {option.label}
              </MenuItem>
            ))}
          </Menu>
        </React.Fragment>
        :
        <DateRangePicker
          onChange={handleDateChange}
          onClose={handleOnCloseDateRange}
          minDate={null}
          maxDate={moment()}
          anchorDirection={ANCHOR_RIGHT}
          focusOnMounted
        />
      }
    </div>
  );
};

DashboardFilters.propTypes = {
  classes: PropTypes.element.isRequired,
  loadDashboardStats: PropTypes.func.isRequired,
  resetDashboard: PropTypes.func.isRequired,
  loadPotentialReach: PropTypes.func.isRequired,
  updateDashboardParams: PropTypes.func.isRequired,
  getReport: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {withTheme: true}),
  connect(
    state => state.dashboard,
    {
      resetDashboard,
      loadDashboardStats,
      updateDashboardParams,
    },
  ),
)(DashboardFilters);
